require('./dist/v-accordion');
module.exports = 'vAccordion';



//////////////////
// WEBPACK FOOTER
// ./~/v-accordion/index.js
// module id = 1576
// module chunks = 1